<template>
    <v-list-item id="sf-ProfileMenuButton" class="text-left ma-2 py-2" :title="user.name" :subtitle="user.email"
        :prepend-avatar="user.picture" link nav>

        <v-menu :close-on-content-click="false" activator="parent" location="end">
            <v-card min-width="300">
                <v-list>
                    <v-list-item :prepend-avatar="user.picture" :title="user.name" :subtitle="user.email" />
                </v-list>

                <v-divider />

                <v-list>
                    <v-list-item>
                        <DarkModeSwitch />
                    </v-list-item>
                    <v-list-item>
                        <ChangePasswordButton />
                    </v-list-item>
                    <v-list-item>
                        <LogoutButton class="float-right" />
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>

    </v-list-item>
</template>

<script>
import DarkModeSwitch from '@/components/switches/DarkModeSwitch';
import ChangePasswordButton from '@/components/buttons/ChangePasswordButton';
import LogoutButton from '@/components/buttons/LogoutButton';

export default {
    name: 'ProfileMenu',
    data() {
        return {
            user: this.$auth0.user,
        }
    },
    props: {
    },
    components: {
        DarkModeSwitch,
        ChangePasswordButton,
        LogoutButton,
    },
}
</script>